<template>
  <el-dialog :title="title" :visible.sync="domVisible" :custom-class="dialogClass" :close-on-click-modal="false" :lock-scroll="false" :before-close="closeDialog">
    <div v-loading.fullscreen="loading">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="mobile">
          <span class="locationcode">{{ruleForm.Nation}}</span>
          <el-input class="login_ipt" :class="ruleForm.Nation!=''?'info_ipt':''" v-model="ruleForm.mobile" placeholder="Please enter your phone number" @input="setInput()">
          </el-input>
        </el-form-item>
        <el-form-item class="login_form_item" prop="Nation">
          <img class="location" :src="LocationIcon" v-if="LocationIcon!=null">
          <!-- <i class="location" :style="LocationIcon!=null?'background-image:url('+LocationIcon+')':''"  v-if="LocationIcon!=null"></i> -->
          <el-select class="login_ipt location_ipt" :class="LocationIcon!=null?'info_ipt':''" v-model="ruleForm.Nation" placeholder="Select country / region" @change='changeLocation'>
            <el-option v-for="(item,index) in nationList" :key="index" :label="item.ChName" :value="item.Code">
              <div class="locationOption">
                <img :src="item.IconUrl">
                <span>{{item.ChName}}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <div class="codeText">
          <el-form-item class="login_form_item" prop="code">
            <el-input class="login_ipt codeIpt" v-model="ruleForm.code" placeholder="Please enter the verification code" @input="setInput()"></el-input>
          </el-form-item>
          <el-button class="login_btn codeBtn" :disabled='isCode' type="primary" @click="getCode('ruleForm')">{{codeText}}</el-button>
        </div>
        <el-form-item class="login_form_item" prop="password">
          <el-input class="login_ipt" v-model="ruleForm.password" :type="flagType" minlength='6' maxlength='20' placeholder="Please enter your password" @input="setInput('password')">
            <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" @click="getFlag()" />
          </el-input>
          <span class="noError">Please enter 6-20 characters with uppercase, lowercase letters and numbers</span>
        </el-form-item>
        <el-form-item class="login_form_item" prop="nickName">
          <el-input class="login_ipt" v-model="ruleForm.nickName" placeholder="Enter your nickname" minlength='1' maxlength='20' @input="setInput('nickName')"></el-input>
        </el-form-item>
        <el-button class="login_btn" :disabled='disabled' type="primary" @click="submitForm('ruleForm')">Sign up</el-button>
        <div class="returnLogin">Already have an account?<span @click="godialog('login','register')">Sign In</span></div>
        <div style="margin-top:20px;">
          <el-checkbox v-model='checked' class="top" label="Remember me" name="type">
            <div class="userText">By signing in, you agree to the <router-link :to="{path:'/useragreement'}">Terms of Service</router-link> <br>and <router-link :to="{path:'/privacyagreement'}">Privacy Policy</router-link>
            </div>
          </el-checkbox>
        </div>
        <!-- <div class="userText U25">登录或Sign up即代表同意 <router-link :to="{path:'/'}">用户协议</router-link> 和 <router-link :to="{path:'/'}">隐私政策</router-link>
        </div> -->
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import { isEmoji, setInfo, login } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    return {
      loading: false,
      times: 60,
      flagType: 'password',
      flag: false,
      checked: false,
      codeText: 'Send Code',
      isCode: true,
      disabled: true,
      dialogClass: 'user',
      nationList: '',
      LocationIcon: null,
      ruleForm: {
        mobile: '',
        password: '',
        nickName: '',
        code: '',
        Nation: '+86'
      },
      rules: {
        code: [
          { required: true, message: 'Please enter the verification code', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: 'Please enter your phone number', trigger: 'blur' },
          { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: 'Please enter a valid phone number', trigger: 'change' },
        ],
        password: [
          { required: true, message: 'Please enter your password', trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: 'Please enter 6-20 characters with uppercase, lowercase letters and numbers', trigger: 'blur' },
        ],
        nickName: [
          { required: true, message: 'Enter your nickname', trigger: 'blur' },
        ]
      },
    }
  },
  props: {
    title: String,
    domVisible: Boolean,
  },
  created() {},
  mounted() {
    let that = this
    that.getNationList()
    window.addEventListener('keydown', function(e) {
      if (!that.disabled) {
        if (e.keyCode === 13) {
          that.submitForm('ruleForm');
        }
      }
    })
    //console.log(this.$interface.SignIn)
  },
  methods: {
    changeLocation(e) {
      let that = this
      that.nationList.map(res => {
        if (res.Code == e) {
          that.LocationIcon = res.IconUrl
        }
      })
    },
    getNationList() {
      let that = this;
      let data = { PageIndex: 1, PageSize: 99 }
      this.$get(this.$interface.GetNationList, data).then(res => {
        if (res.Result != 0) {
          that.nationList = res.Data
          that.changeLocation('+86');
        }
      })
    },
    // 点击快捷跳转 登陆
    godialog(toval, val) {
      this.$emit('closeDialog', val, false)
      this.$emit('godialog', toval, true)
    },
    //获取验证码
    getCode(formName) {
      let that = this;
      that.isCode = true;
      this.$refs[formName].validateField('mobile', (val) => {
        if (val == "") {
          that.isCode = true;
          if (that.times == 60) {
            that.codeText = that.times + 's';
          }
          that.timer = setInterval(() => {
            that.times--;
            that.codeText = that.times + 's';
            if (that.times === 0) {
              clearInterval(that.timer)
              that.times = 60;
              that.codeText = 'Send Code';
              that.isCode = false;
            }
          }, 1000)
          var Nation = that.ruleForm.Nation
          if (Nation.indexOf('+') > -1) {
            Nation = Nation.slice(1)
          }
          let data = {
            NationCode: Nation,
            mobile: that.ruleForm.mobile,
            type: 1
          }
          this.$post(this.$interface.SendMobileCode, data).then(res => {
            if (res.Result != 0) {} else {
              that.times = 60;
              that.codeText = 'Send Code';
              that.isCode = false;
              clearInterval(that.timer);
              this.$message.error(res.Msg);
            }
          }).catch({})
        } else {
          that.isCode = true
        }
      })
    },
    // 关闭弹框
    closeDialog() {
      this.$emit('closeDialog', 'register', false)
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
    },
    // 判断input是否有值
    setInput(val) {
      this.$refs['ruleForm'].validateField('mobile', (val) => {
        if (val == "") {
          this.isCode = false
        } else {
          this.isCode = true
        }
      })
      // if (this.ruleForm.mobile != '') {
      //   this.isCode = false
      // } else {
      //   this.isCode = true
      // }
      if (val == 'nickName' || val == 'password') {
        this.ruleForm[val] = isEmoji(this.ruleForm[val], 1)
      }
      if (this.ruleForm.mobile != '' && this.ruleForm.password != '' && this.ruleForm.nickName != '' && this.ruleForm.code != '') {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    // 注册
    submitForm(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.loading = true;
          that.disabled = true;

          if (that.checked) {
            let data = that.ruleForm
            if (that.nationList) {
              that.nationList.map(res => {
                if (res.Code == that.ruleForm.Nation) {
                  that.ruleForm.Nation = res.ChName
                }
              })
            }
            that.$post(that.$interface.Register, data).then(res => {
              if (res.Result != 0) {
                login(res.Data)
                that.closeDialog()
                //this.closeDialog();
              } else {
                that.$message.error(res.Msg);
              }
              that.loading = false;
            }).catch({})
          } else {
            that.$message.error('Please agree to the terms');
            that.loading = false;
            that.disabled = false
          }
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

.location_ipt {
  width: 100%;
}

/deep/.info_ipt .el-input .el-input__inner,
/deep/.login_ipt.info_ipt .el-input__inner {
  padding-left: 40px;
}

.locationOption {
  display: flex;
  align-items: center;
  width: 258px;
}

.locationOption img {
  width: 24px;
  height: 16px;
  border: 0.2px solid #F0F0F0;
  border-radius: 2px;
  margin-right: 4px;
}

.locationcode {
  position: absolute;
  z-index: 9;
  color: var(--text-secondary);
  top: 2px;
  left: 10px;
}

.location {
  width: 24px;
  height: 16px;
  border: 0.2px solid #F0F0F0;
  border-radius: 2px;
  position: absolute;
  z-index: 9;
  top: 13px;
  left: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/register.vue